// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 909) return "static/chunks/909-620d55f3c629a1e4.js";
	if (chunkId === 95) return "static/chunks/95-66f1f6bbf91dd399.js";
	if (chunkId === 619) return "static/chunks/619-49eefa8db259f5d4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"236":"1b96809fecefd207","601":"d672b95fa6cc3336","767":"8525f08deeacb1ef","884":"78190953540fc7f1","981":"ae29515b60501566"}[chunkId] + ".js";
};